import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import PersonnelEventsForEventManagersServices from '@/api/resources/personnelEvents/personnelEventsForEventManagers/personnelEventsForEventManagersServices'
import { Nullable } from '@/shared/types/app.types'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { isNil, omitBy } from 'lodash'

export class PersonnelEventsForEventManagersDatasource<T> extends PaginatorLaboratoryDatasource<T> {
    private readonly _externalFilterModel: Nullable<CommonFilterModel>

    constructor(laboratoryId: number, externalFilterModel?: CommonFilterModel) {
        super(PersonnelEventsForEventManagersServices, laboratoryId)
        this._externalFilterModel = omitBy(externalFilterModel, isNil)
    }

    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<T>> {
        if (!this.service) {
            throw new Error('undefined service')
        }
        const _filterModel =
            this._externalFilterModel
                ? Object.assign(filterModel, this._externalFilterModel)
                : filterModel
        return this.service.paginator(_filterModel, params, this.laboratoryId)
    }
}
